module.exports = __webpack_public_path__ + "static/media/mision.9ceccf0f.jpg";